// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import { Pagination } from 'element-ui';

import App from './App'
import router from './router'

//引入store
import store from './store'

import services from './utils/services'
Vue.use(services);

Vue.config.productionTip = false

// const config = {
//   data: function () {
//     return {
//       naviType: 'pc',
//     }
//   }
// }

//样式重置
import '../src/assets/style/main.css'
import '../src/assets/style/minireset.min.css'
import 'animate.css'
// import {WOW} from 'wow.js'

// 屏幕自适应
import {
  debounce
} from './utils/util'

let screenWidth = document.body.clientWidth;
// console.log("screenWidth:",screenWidth)
store.commit('setScreenWidthFun', screenWidth)

var width = 1920;

if(screenWidth > 768){
  width = 1920;
}else{
  width = 375;
}
// window.innerWidth || 
const deviceW = document.documentElement.clientWidth,
    fontSize = deviceW / width * 100;
  document.documentElement.style.fontSize = fontSize + 'px';
  // console.log("window1:",window)
  // console.log("document.documentElement.clientWidth1:",document.documentElement.clientWidth)
  // console.log("deviceW:",deviceW)
  // console.log("width:", width)
  // console.log("fontSize初始：", fontSize)



window.onresize = debounce(() => {
  let screenWidth2 = document.body.clientWidth;
  store.commit('setScreenWidthFun', screenWidth2)

  if(screenWidth2 > 768){
    width = 1920;
  }else{
    width = 375;
  }
  

  const deviceW = document.documentElement.clientWidth,
    fontSize = deviceW / width * 100;
  
  // console.log("window2:",window)
  // console.log("document.documentElement.clientWidth2:",document.documentElement.clientWidth)
  // console.log("deviceW:",deviceW)
  // console.log("width:", width)
  // console.log("fontSize变化：", fontSize)
  document.documentElement.style.fontSize = fontSize + 'px';
  
}, 200)

/* eslint-disable no-new */
// Vue.mixin(config);


Vue.use(Pagination);

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js